/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Done_TitleInputs */

const es_walkthrough_done_title = /** @type {(inputs: Walkthrough_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Todo listo!`)
};

const en_walkthrough_done_title = /** @type {(inputs: Walkthrough_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all set!`)
};

/**
* | output |
* | --- |
* | "You're all set!" |
*
* @param {Walkthrough_Done_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_done_title = /** @type {((inputs?: Walkthrough_Done_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Done_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_done_title(inputs)
	return en_walkthrough_done_title(inputs)
});
export { walkthrough_done_title as "walkthrough.done_title" }